window.Webflow ||= [];
window.Webflow.push(() => {
  const url = 'https://portalapi.fjellheisen.no/api/external/operation/website';
  const norApiMessage = document.querySelector('[api-message="nor"]');
  const engApiMessage = document.querySelector('[api-message="eng"]');

  async function showApiMessage() {
    try {
      const now = new Date(Date.now() + 20 * 60);
      const response = await fetch(url);
      const data = await response.json();
      const items = data.messages;

      if (items.length > 0) {
        const normsg = items[items.length - 1].nor.message;
        const engmsg = items[items.length - 1].eng.message;
        const nornextopen = items[items.length - 1].nor.nextOpen;
        const engnextopen = items[items.length - 1].eng.nextOpen;
        const startString = items[items.length - 1].startTime;
        const endString = items[items.length - 1].endTime;
        const startDate = new Date(startString);
        const endDate = new Date(endString);

        console.log(data);
        //console.log(`Start STRING     ${startString}`);
        console.log(`End STRING     ${endString}`);
        // console.log(`Start Date     ${startDate}`);
        console.log(`End Date     ${endDate}`);
        // console.log(`Now     ${now}`);
        // console.log(`Now STRING     ${now.toString()}`);

        if (norApiMessage != null) {
          endString === null
            ? norApiMessage.classList.remove('is-hidden')
            : now >= startDate && now <= endDate
            ? norApiMessage.classList.remove('is-hidden')
            : null;
          norApiMessage.innerText = `${normsg}\n Neste åpne: ${nornextopen}`;
        } else if (engApiMessage != null) {
          endString === null
            ? engApiMessage.classList.remove('is-hidden')
            : now >= startDate && now <= endDate
            ? engApiMessage.classList.remove('is-hidden')
            : null;
          engApiMessage.innerText = `${engmsg}\n Next open: ${engnextopen}`;
        }
      } else {
        console.log(`API object is empty!`);
      }
    } catch (error) {
      console.log(error);
    }
  }

  showApiMessage();
});
